
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Form, Row, Col, Modal, Button, Table } from 'react-bootstrap';
import Select from "../../AppSelect";
import { Controller, FormProvider, useForm } from 'react-hook-form';
import Swal from 'sweetalert2';

import GoogleMapsAutocomplete from '../../GoogleMapsAutocomplete';
import CustomRadioButton from '../../Inputs/RadioButton';
import CustomCheckbox from '../../Inputs/CheckBox';
import { CompanyTypesEnum, OperatorTierEnum } from '../../../utils/enumsUtil';
import { isNullOrUndefined } from '../../../utils/functionsUtils';
import { customStyles } from '../../../constants/customSelectStyles';

const UpsertCompany = ({
    show,
    handleClose,
    company,
    reduxPostCompany,
    successfulCreateCompany,
    errorsCreateCompany,
    reduxPatchCompany,
    successfulUpdateCompany,
    errorsUpdateCompany,
    reduxGetBranches,
    branches,
    reduxGetCountries,
    countries,
    reduxGetDepartmentByCountry,
    departmentsByCountry,
    reduxGetCitiesByDepartment,
    citiesByDepartment,
    reduxGetNeighborhoodsByCity,
    neighborhoodsByCity,
    reduxGetOrderTypes,
    orderTypes,
    reduxGetPaymentTypes,
    paymentTypes,
    reduxDeleteOperatorBranch,
    reduxResetCompanyForm,
    reduxResetDepartmentsByCountry,
    reduxResetCitiesByDepartment,
    reduxResetNeighborhoodsByCity,
    reduxGetLogisticsServiceTypes,
    logisticsServiceTypes,
}) => {

    const modalForm = useForm({
        defaultValues: {
            companyType: null,
            description: null,
            businessName: null,
            nit: null,
            phone: null,
            email: null,
            postalCode: null,
            country: null,
            department: null,
            city: null,
            neighborhood: null,
            systemKey: null,
            genericName: null,
            prefix: null,
            serviceType: null,
            companyOrderTypes: [],
            operatorServiceCapabilities: [],
            companyPaymentTypes: [],
            productServiceCode: null,
            productServiceDescription: null,
            weightUnitCode: null,
            weightUnitDescription: null,
            serviceTypeSelected: null,
            operatorTier: null,
        },
    });

    const operatorBranchForm = useForm({
        defaultValues: {
            operatorsBranch: [],
        },
    });

    const [valueManualAddress, setValueManualAddress] = useState('');
    const [isCartaPorteChecked, setIsCartaPorteChecked] = useState(false);

    const serviceTypeSelected = modalForm.watch('serviceTypeSelected', '');
    const operatorBranchWatcher = operatorBranchForm.watch('operatorsBranch', []);
    const countryWatcher = modalForm.watch('country', null);
    const companyTypeWatcher = modalForm.watch('companyType', '');

    const servicesTypes = [
        {
            label: 'Ultima Milla',
            value: 'UM',
            checked: !serviceTypeSelected || serviceTypeSelected === 'UM',
        },
        { label: 'Fulfillment', value: 'FM', checked: serviceTypeSelected === 'FM' },
        { label: 'Cross Docking', value: 'CD', checked: serviceTypeSelected === 'CD' },
    ];

    const operatorTierOptions = [
        { value: OperatorTierEnum.LARGE, label: 'Large' },
        { value: OperatorTierEnum.NOT_LARGE, label: 'Not Large' },
    ];

    const CompanyTypes = [
        { value: 'DSP', label: 'DSP' },
        { value: 'OPERATOR-INV', label: 'Operador de Inventario' },
        { value: 'OPERATOR-LOG', label: 'Operador Logístico' },
        { value: 'SHIPPER', label: 'Remitente' }
    ];

    useEffect(() => {
        if (show) {
            reduxGetOrderTypes();
            reduxGetPaymentTypes();
            reduxGetLogisticsServiceTypes();
            reduxGetCountries({
                page: 1,
                offset: 1000,
                search: '',
                isActive: true,
            });
            reduxGetBranches({
                page: 1,
                offset: 1000,
                search: '',
                isActive: true,
            });
        }
    }, [show])

    useEffect(() => {
        if (company) {
            const companyType = CompanyTypes.find((type) => type.value === company.companyType);
            const operatorTierSelected = operatorTierOptions.find((tier) => tier.value === company.operatorTier);
            // Caso edición
            modalForm.reset({
                companyType: companyType,
                description: company.description,
                businessName: company.businessName,
                email: company.email,
                postalCode: company.postalCode,
                nit: company.nit,
                phone: company.phone,
                zipCode: company.zipCode,
                currentAddress: company.address,
                genericName: company.genericName,
                country: company.country,
                department: company.department,
                city: company.city,
                neighborhood: company.neighborhood,
                serviceType: company.serviceType,
                operatorTier: operatorTierSelected,
                companyOrderTypes: company.companyOrderTypes
                    ? company.companyOrderTypes.filter(o => o.isActive).map(o => o.idOrderType)
                    : [],
                companyPaymentTypes: company.companyPaymentTypes
                    ? company.companyPaymentTypes.filter(o => o.isActive).map(o => o.idPaymentType)
                    : [],
                operatorServiceCapabilities: company.operatorServiceCapabilities
                    ? company.operatorServiceCapabilities.map(o => o.idServiceType)
                    : [],
                weightUnitDescription: company.cartaPorte?.weightUnitDescription || '',
                weightUnitCode: company.cartaPorte?.weightUnitCode || '',
                productServiceDescription: company.cartaPorte?.productServiceDescription || '',
                productServiceCode: company.cartaPorte?.productServiceCode || '',
            });

            operatorBranchForm.reset({
                operatorsBranch: company.operatorBranches?.map(o => ({
                    idBranch: o.idBranch,
                    branch: { value: o.idBranch, label: o.branch.branchName },
                    account: o.account,
                    requestDelete: false,
                })) || [],
            });

            setValueManualAddress(company.address);

            if (company.cartaPorte) {
                setIsCartaPorteChecked(true);
            }
        }
    }, [company])

    // Setea el pais seleccionado en el select desde editar
    useEffect(() => {
        if (countries?.items?.length > 0 && company) {
            const country = countries.items.find((country) => country.idCountry === parseInt(company.country));
            if (country) {
                modalForm.setValue('country', { value: country.idCountry, label: country.description });
                reduxGetDepartmentByCountry({
                    idCountry: country.idCountry,
                })
            }
        }
    }, [countries, company])

    // Setea el departamento seleccionado en el select desde editar
    useEffect(() => {
        if (departmentsByCountry?.length > 0 && company) {
            const department = departmentsByCountry.find((department) => department.idDepartment === parseInt(company.department));
            if (department) {
                modalForm.setValue('department', { value: department.idDepartment, label: department.description });
                reduxGetCitiesByDepartment({
                    idDepartment: department.idDepartment,
                })
            }
        }
    }, [departmentsByCountry, company])

    // Setea la ciudad seleccionada en el select desde editar
    useEffect(() => {
        if (citiesByDepartment?.length > 0 && company) {
            const city = citiesByDepartment.find((city) => city.idCity === parseInt(company.city));
            if (city) {
                modalForm.setValue('city', { value: city.idCity, label: city.description });
                reduxGetNeighborhoodsByCity({
                    idCity: city.idCity,
                })
            }
        }
    }, [citiesByDepartment, company])

    // Setea el barrio seleccionado en el select desde editar
    useEffect(() => {
        if (neighborhoodsByCity?.items?.length > 0 && company) {
            const neighborhood = neighborhoodsByCity.items.find((neighborhood) => neighborhood.idNeighborhood === parseInt(company.neighborhood));
            if (neighborhood) {
                modalForm.setValue('neighborhood', { value: neighborhood.idNeighborhood, label: neighborhood.description });
            }
        }
    }, [neighborhoodsByCity, company])

    useEffect(() => {
        switch (companyTypeWatcher?.value) {
            case CompanyTypesEnum.DSP:
                modalForm.setValue('systemKey', CompanyTypesEnum.DSP);
                modalForm.setValue('prefix', company?.prefix || null);
                modalForm.setValue('serviceType', null);
                modalForm.setValue('weightUnitDescription', null);
                modalForm.setValue('weightUnitCode', null);
                modalForm.setValue('productServiceDescription', null);
                modalForm.setValue('productServiceCode', null);
                modalForm.setValue('operatorBranches', []);
                break;
            case CompanyTypesEnum.INVENTORY_OPERATOR:
                modalForm.setValue('systemKey', null);
                modalForm.setValue('prefix', null);
                modalForm.setValue('serviceType', null);
                modalForm.setValue('companyOrderTypes', []);
                modalForm.setValue('weightUnitDescription', null);
                modalForm.setValue('weightUnitCode', null);
                modalForm.setValue('productServiceDescription', null);
                modalForm.setValue('productServiceCode', null);
                modalForm.setValue('operatorBranches', []);
                modalForm.setValue('operatorTier', null);
                modalForm.setValue('operatorServiceCapabilities', []);
                break;
            case CompanyTypesEnum.LOGISTICS_OPERATOR:
                modalForm.setValue('systemKey', company?.systemKey || null);
                modalForm.setValue('prefix', null);
                modalForm.setValue('serviceType', null);
                modalForm.setValue('weightUnitDescription', null);
                modalForm.setValue('weightUnitCode', null);
                modalForm.setValue('productServiceDescription', null);
                modalForm.setValue('productServiceCode', null);
                break;
            case CompanyTypesEnum.SHIPPER:
                modalForm.setValue('systemKey', null);
                modalForm.setValue('prefix', null);
                modalForm.setValue('serviceType', company?.serviceType || 'UM');
                modalForm.setValue('operatorBranches', []);
                modalForm.setValue('operatorTier', null);
                modalForm.setValue('operatorServiceCapabilities', []);
                break;
            default:
                break;
        }
    }, [companyTypeWatcher]);

    useEffect(() => {
        if (successfulCreateCompany || errorsCreateCompany) {
            Swal.fire({
                icon: successfulCreateCompany ? 'success' : 'error',
                title: successfulCreateCompany ? 'Compañía creada correctamente' : 'Error al crear la compañía',
                showConfirmButton: true,
            }).then((result) => {
                if ((result.isConfirmed || result.isDismissed) && successfulCreateCompany) closeModal();
            });
        }
    }, [successfulCreateCompany, errorsCreateCompany]);

    useEffect(() => {
        if (successfulUpdateCompany || errorsUpdateCompany) {
            Swal.fire({
                icon: successfulUpdateCompany ? 'success' : 'error',
                title: successfulUpdateCompany ? 'Compañía actualizada correctamente' : 'Error al actualizar la compañía',
                showConfirmButton: true,
            }).then((result) => {
                if ((result.isConfirmed || result.isDismissed) && successfulUpdateCompany) closeModal();
            });
        }
    }, [successfulUpdateCompany, errorsUpdateCompany]);

    const autocompleteAddresses = (data) => {
        if (data && data.address_components) {
            const address = data.address_components.map((ad) => ad.long_name).join(', ');
            setValueManualAddress(address);
            const countryAddress = data.address_components
                .find((ad) => ad.types[0] === 'country')
                ?.long_name.toUpperCase();
            data.address_components
                ? modalForm.setValue('manual', data.address_components)
                : modalForm.setValue('manual', data);
            modalForm.setValue('country', null);
            modalForm.setValue('department', '');
            modalForm.setValue('city', '');
        }
    };

    const branchFormIsValid = () => {
        operatorBranchForm.clearErrors();
        var isValid = true;
        const data = operatorBranchForm.getValues();

        if (isNullOrUndefined(data.branch)) {
            operatorBranchForm.setError('branch', {
                type: 'manual',
                message: 'El HUB es requerido',
            });
            isValid = false;
        }

        if (isNullOrUndefined(data.account)) {
            operatorBranchForm.setError('account', {
                type: 'manual',
                message: 'La cuenta es requerida',
            });
            isValid = false;
        }

        return isValid;
    };

    const addBranch = () => {
        if (!branchFormIsValid()) return;
        const data = operatorBranchForm.getValues();

        const newBranch = {
            idBranch: data.branch.value,
            branch: data.branch,
            account: data.account,
            requestDelete: false,
        };

        const isDuplicate = operatorBranchWatcher.some((newBranchExist) => {
            return newBranchExist.idBranch === newBranch.idBranch;
        });

        if (isDuplicate) {
            Swal.fire('No se puede agregar el HUB porque ya se asignó.');
            return;
        }

        operatorBranchForm.setValue('operatorsBranch', [...operatorBranchWatcher, newBranch]);

        operatorBranchForm.setValue('branch', null);
        operatorBranchForm.setValue('account', null);
    };

    const handleRemoveOperator = (element) => {
        Swal.fire({
            html: `¿Está seguro de eliminar este HUB?`,
            icon: 'question',
            showConfirmButton: true,
            confirmButtonText: 'SI',
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                const newOperatorsArray = operatorBranchWatcher.filter((item) => item.idBranch !== element.idBranch);
                operatorBranchForm.setValue('operatorsBranch', newOperatorsArray);
                if (element.requestDelete) {
                    reduxDeleteOperatorBranch({
                        idOperatorBranch: element.idOperatorBranch,
                    });
                }
            }
        });
    };

    const onSubmit = (data) => {
        const cartaPorte = isCartaPorteChecked
            ? {
                productServiceCode: data.productServiceCode,
                productServiceDescription: data.productServiceDescription,
                weightUnitCode: data.weightUnitCode,
                weightUnitDescription: data.weightUnitDescription,
            }
            : null;

        let companyDTO = {
            companyType: data.companyType.value,
            serviceType: data.serviceType,
            description: data.description,
            businessName: data.businessName,
            nit: data.nit,
            phone: data.phone,
            email: data.email,
            postalCode: data.postalCode,
            address: data.currentAddress,
            country: data.country?.value || null,
            department: data.department?.value || null,
            city: data.city?.value || null,
            neighborhood: data.neighborhood?.value || null,
            systemKey: data.systemKey,
            cartaPorte: cartaPorte,
            genericName: data.genericName,
            operatorBranches: operatorBranchWatcher?.map((branch) => {
                return {
                    account: branch.account,
                    idBranch: branch.idBranch,
                };
            }),
            prefix: data.prefix,
            operatorTier: data.operatorTier?.value || null,
        };

        switch (data.companyType.value) {
            case CompanyTypesEnum.SHIPPER:
                const allOrderTypeIds = orderTypes.map(orderType => orderType.idOrderType);

                const orderTypesWithStatus = allOrderTypeIds.map(idOrderType => ({
                    idOrderType,
                    isActive: (data.companyOrderTypes || []).includes(idOrderType)
                }));

                const allPaymentTypeIds = paymentTypes.map(paymentType => paymentType.idPaymentType);

                const paymentTypesWithStatus = allPaymentTypeIds.map(idPaymentType => ({
                    idPaymentType,
                    isActive: (data.companyPaymentTypes || []).includes(idPaymentType)
                }));

                companyDTO.orderTypes = orderTypesWithStatus;
                companyDTO.paymentTypes = paymentTypesWithStatus;
                break;
            case CompanyTypesEnum.DSP:
            case CompanyTypesEnum.LOGISTICS_OPERATOR:
                companyDTO.operatorServiceCapabilities = data.operatorServiceCapabilities.map(value => ({
                    idServiceType: value,
                }));
                break;
            default:
                break;
        }

        if (company) reduxPatchCompany({ ...companyDTO, id: company.idCompany });
        else reduxPostCompany({ ...companyDTO });
    };

    const closeModal = () => {
        reduxResetCompanyForm();
        modalForm.reset({
            companyType: null,
            description: null,
            businessName: null,
            nit: null,
            phone: null,
            email: null,
            postalCode: null,
            country: null,
            department: null,
            city: null,
            neighborhood: null,
            systemKey: null,
            genericName: null,
            prefix: null,
            serviceType: null,
            companyOrderTypes: [],
            companyPaymentTypes: [],
            operatorServiceCapabilities: [],
            productServiceCode: null,
            productServiceDescription: null,
            weightUnitCode: null,
            weightUnitDescription: null,
            serviceTypeSelected: null,
            operatorTier: null,
        });
        setValueManualAddress(null);
        operatorBranchForm.reset({
            operatorsBranch: [],
        });
        setIsCartaPorteChecked(false);
        reduxResetDepartmentsByCountry();
        reduxResetCitiesByDepartment();
        reduxResetNeighborhoodsByCity();
        handleClose();
    };

    return (
        <Modal
            size="xl"
            show={show}
            onHide={closeModal}
            onEscapeKeyDown={closeModal}
            backdrop="static"
            keyboard={true}
        >
            {
                // Se garantiza el renderizado completo de los componentes para establecer las reglas de los inputs
                show && (
                    <FormProvider {...modalForm}>
                        <Modal.Header closeButton>
                            <Modal.Title>{company ? 'Editar' : 'Nueva'} empresa</Modal.Title>
                        </Modal.Header>
                        <Form className='m-3 d-flex flex-column gap-1' onSubmit={modalForm.handleSubmit(onSubmit)}>
                            <Form.Group as={Row}>
                                <Col md={4}>
                                    <Form.Label>Tipo de empresa *</Form.Label>
                                    <Controller
                                        control={modalForm.control}
                                        name="companyType"
                                        rules={{ required: 'Seleccione el tipo de empresa' }}
                                        render={({ field }) => (
                                            <>
                                                <Select
                                                    {...field}
                                                    isClearable
                                                    styles={customStyles}
                                                    onChange={(option) => {
                                                        field.onChange(option || '')
                                                    }}
                                                    options={CompanyTypes && CompanyTypes.length > 0 ? CompanyTypes : []}
                                                />
                                                {modalForm.formState.errors.companyType && (
                                                    <span className="error-message">
                                                        {modalForm.formState.errors.companyType.message}
                                                    </span>
                                                )}
                                            </>
                                        )}
                                    />
                                </Col>
                            </Form.Group>
                            {/* Grupo 1: Información básica de la empresa */}
                            <Form.Group as={Row}>
                                <Col md={4}>
                                    <Form.Label>Razón social *</Form.Label>
                                    <Controller
                                        control={modalForm.control}
                                        name="description"
                                        rules={{ required: 'La razón social es requerida' }}
                                        render={({ field }) => (
                                            <>
                                                <Form.Control
                                                    className={`form-control ${modalForm.formState.errors.description && 'is-invalid'
                                                        }`}
                                                    {...field}
                                                />
                                                {modalForm.formState.errors.description && (
                                                    <span className="error-message">
                                                        {modalForm.formState.errors.description.message}
                                                    </span>
                                                )}
                                            </>
                                        )}
                                    />
                                </Col>
                                <Col md={4}>
                                    <Form.Label>Nombre comercial *</Form.Label>
                                    <Controller
                                        control={modalForm.control}
                                        name="businessName"
                                        rules={{ required: 'El nombre comercial es requerido' }}
                                        render={({ field }) => (
                                            <>
                                                <Form.Control
                                                    className={`form-control ${modalForm.formState.errors.businessName && 'is-invalid'
                                                        }`}
                                                    {...field}
                                                />
                                                {modalForm.formState.errors.businessName && (
                                                    <span className="error-message">
                                                        {modalForm.formState.errors.businessName.message}
                                                    </span>
                                                )}
                                            </>
                                        )}
                                    />
                                </Col>
                                <Col md={4}>
                                    <Form.Label>Documento empresa *</Form.Label>
                                    <Controller
                                        control={modalForm.control}
                                        name="nit"
                                        rules={{
                                            required: 'El documento es requerido y debe ser único por empresa',
                                        }}
                                        render={({ field }) => (
                                            <>
                                                <Form.Control
                                                    className={`form-control ${modalForm.formState.errors.nit && 'is-invalid'
                                                        }`}
                                                    {...field}
                                                />
                                                {modalForm.formState.errors.nit && (
                                                    <span className="error-message">
                                                        {modalForm.formState.errors.nit.message}
                                                    </span>
                                                )}
                                            </>
                                        )}
                                    />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row}>
                                <Col md={4}>
                                    <Form.Label>Teléfono *</Form.Label>
                                    <Controller
                                        control={modalForm.control}
                                        name="phone"
                                        rules={{
                                            required: 'El teléfono es requerido',
                                            pattern: {
                                                value: /^(\+){0,1}\d*$/,
                                                message: 'Digite un teléfono válido',
                                            },
                                        }}
                                        render={({ field }) => (
                                            <>
                                                <Form.Control
                                                    className={`form-control ${modalForm.formState.errors.phone && 'is-invalid'
                                                        }`}
                                                    type="number"
                                                    {...field}
                                                />
                                                {modalForm.formState.errors.phone && (
                                                    <span className="error-message">
                                                        {modalForm.formState.errors.phone.message}
                                                    </span>
                                                )}
                                            </>
                                        )}
                                    />
                                </Col>
                                <Col md={4}>
                                    <Form.Label>Correo *</Form.Label>
                                    <Controller
                                        control={modalForm.control}
                                        name="email"
                                        rules={{
                                            required: 'El correo es requerido',
                                            pattern: {
                                                value: /\S+@\S+\.\S+/,
                                                message: 'Digite un correo electrónico válido',
                                            },
                                        }}
                                        render={({ field }) => (
                                            <>
                                                <Form.Control
                                                    className={`form-control ${modalForm.formState.errors.email && 'is-invalid'
                                                        }`}
                                                    {...field}
                                                />
                                                {modalForm.formState.errors.email && (
                                                    <span className="error-message">
                                                        {modalForm.formState.errors.email.message}
                                                    </span>
                                                )}
                                            </>
                                        )}
                                    />
                                </Col>
                                <Col sm={4}>
                                    <Form.Label>Código postal *</Form.Label>
                                    <Controller
                                        control={modalForm.control}
                                        name="postalCode"
                                        rules={{
                                            required: 'El código postal es requerido',
                                            pattern: {
                                                value: /^\d*$/,
                                                message: 'Digite un código postal válido',
                                            },
                                        }}
                                        render={({ field }) => (
                                            <>
                                                <Form.Control
                                                    className={`form-control ${modalForm.formState.errors.postalCode && 'is-invalid'
                                                        }`}
                                                    {...field}
                                                    type="number"
                                                />
                                                {modalForm.formState.errors.postalCode && (
                                                    <span className="error-message">
                                                        {modalForm.formState.errors.postalCode.message}
                                                    </span>
                                                )}
                                            </>
                                        )}
                                    />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row}>
                                <Col sm={12}>
                                    <GoogleMapsAutocomplete
                                        id={'currentAddress'}
                                        required={true}
                                        value={valueManualAddress}
                                        onChange={autocompleteAddresses}
                                    />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row}>
                                <Col md={3}>
                                    <Form.Label>País *</Form.Label>
                                    <Controller
                                        control={modalForm.control}
                                        name="country"
                                        rules={{
                                            required: 'El país es requerido',
                                        }}
                                        render={({ field }) => (
                                            <>
                                                <Select
                                                    {...field}
                                                    isClearable
                                                    styles={customStyles}
                                                    onChange={(option) => {
                                                        field.onChange(option || null);
                                                        modalForm.setValue('department', null);
                                                        modalForm.setValue('city', null);
                                                        modalForm.setValue('neighborhood', null);

                                                        if (!option) {
                                                            reduxResetDepartmentsByCountry();
                                                            reduxResetCitiesByDepartment();
                                                            reduxResetNeighborhoodsByCity();
                                                        } else {
                                                            reduxGetDepartmentByCountry({
                                                                idCountry: option.value,
                                                            })
                                                        }
                                                    }}
                                                    options={
                                                        countries && Object.keys(countries).length > 0
                                                            ? countries.items
                                                                .filter((f) => f.isActive)
                                                                .map((ele, key) => ({
                                                                    value: ele.idCountry,
                                                                    label: ele.description,
                                                                }))
                                                            : []
                                                    }
                                                />
                                                {modalForm.formState.errors.country && (
                                                    <span className="error-message">
                                                        {modalForm.formState.errors.country.message}
                                                    </span>
                                                )}
                                            </>
                                        )}
                                    />
                                </Col>
                                <Col md={3}>
                                    <Form.Label>Departamento *</Form.Label>
                                    <Controller
                                        control={modalForm.control}
                                        name="department"
                                        rules={{
                                            required: 'El departamento y/o provincia es requerido',
                                        }}
                                        render={({ field }) => (
                                            <>
                                                <Select
                                                    {...field}
                                                    isClearable
                                                    styles={customStyles}
                                                    onChange={(option) => {
                                                        field.onChange(option || null);
                                                        modalForm.setValue('city', null);
                                                        modalForm.setValue('neighborhood', null);

                                                        if (!option) {
                                                            reduxResetCitiesByDepartment();
                                                            reduxResetNeighborhoodsByCity();
                                                        } else {
                                                            reduxGetCitiesByDepartment({
                                                                idDepartment: option.value,
                                                            })
                                                        }
                                                    }}
                                                    options={
                                                        departmentsByCountry && Object.keys(departmentsByCountry).length > 0
                                                            ? departmentsByCountry
                                                                .filter((f) => f.isActive)
                                                                .map((ele) => ({
                                                                    value: ele.idDepartment,
                                                                    label: ele.description,
                                                                }))
                                                            : []
                                                    }
                                                />
                                                {modalForm.formState.errors.department && (
                                                    <span className="error-message">
                                                        {modalForm.formState.errors.department.message}
                                                    </span>
                                                )}
                                            </>
                                        )}
                                    />
                                </Col>
                                <Col sm={3}>
                                    <Form.Label>Ciudad *</Form.Label>
                                    <Controller
                                        control={modalForm.control}
                                        name="city"
                                        rules={{
                                            required: 'La ciudad es requerida',
                                        }}
                                        render={({ field }) => (
                                            <>
                                                <Select
                                                    {...field}
                                                    isClearable
                                                    styles={customStyles}
                                                    onChange={
                                                        (option) => {
                                                            field.onChange(option || null);
                                                            modalForm.setValue('neighborhood', null)
                                                            if (!option) {
                                                                reduxResetNeighborhoodsByCity()
                                                            } else {
                                                                reduxGetNeighborhoodsByCity({
                                                                    idCity: option.value,
                                                                })
                                                            }
                                                        }
                                                    }
                                                    options={
                                                        citiesByDepartment && Object.keys(citiesByDepartment).length > 0
                                                            ? citiesByDepartment
                                                                .filter((f) => f.isActive)
                                                                .map((ele) => ({
                                                                    value: ele.idCity,
                                                                    label: ele.description,
                                                                }))
                                                            : []
                                                    }
                                                />
                                                {modalForm.formState.errors.city && (
                                                    <span className="error-message">
                                                        {modalForm.formState.errors.city.message}
                                                    </span>
                                                )}
                                            </>
                                        )}
                                    />
                                </Col>
                                <Col sm={3}>
                                    <Form.Label>Barrio</Form.Label>
                                    <Controller
                                        control={modalForm.control}
                                        name="neighborhood"
                                        render={({ field }) => (
                                            <>
                                                <Select
                                                    {...field}
                                                    isClearable
                                                    styles={customStyles}
                                                    onChange={(option) =>
                                                        field.onChange(option || null)
                                                    }
                                                    options={
                                                        neighborhoodsByCity && Object.keys(neighborhoodsByCity).length > 0
                                                            ? neighborhoodsByCity
                                                                .filter((f) => f.isActive)
                                                                .map((ele) => ({
                                                                    value: ele.idNeighborhood,
                                                                    label: ele.description,
                                                                }))
                                                            : []
                                                    }
                                                />
                                            </>
                                        )}
                                    />
                                </Col>
                            </Form.Group>
                            <Form.Group as={Row}>
                                <Col sm={4}>
                                    <Form.Label>Llave del sistema</Form.Label>
                                    <Controller
                                        control={modalForm.control}
                                        name="systemKey"
                                        render={({ field }) => (
                                            <>
                                                <Form.Control
                                                    {...field}
                                                    readOnly={companyTypeWatcher?.value === CompanyTypesEnum.DSP}
                                                />
                                            </>
                                        )}
                                    />
                                </Col>
                                <Col sm={4}>
                                    <Form.Label>Nombre Genérico</Form.Label>
                                    <Controller
                                        control={modalForm.control}
                                        name="genericName"
                                        render={({ field }) => (
                                            <>
                                                <Form.Control {...field} />
                                            </>
                                        )}
                                    />
                                </Col>
                                { /* Grupo 2: Campos específicos DSP */
                                    companyTypeWatcher?.value === CompanyTypesEnum.DSP && (
                                        <>
                                            <Col sm={4}>
                                                <Form.Label>Prefijo *</Form.Label>
                                                <Controller
                                                    control={modalForm.control}
                                                    name="prefix"
                                                    rules={{
                                                        required: {
                                                            value: true,
                                                            message: 'El prefijo es requerido',
                                                        },
                                                        ...(company
                                                            ? {}
                                                            : {
                                                                minLength: {
                                                                    value: 6,
                                                                    message: 'El prefijo debe tener exactamente 6 caracteres',
                                                                },
                                                                maxLength: {
                                                                    value: 6,
                                                                    message: 'El prefijo debe tener exactamente 6 caracteres',
                                                                },
                                                                pattern: {
                                                                    value: /^[A-Z0-9]{6}$/,
                                                                    message:
                                                                        'El prefijo no debe incluir caracteres especiales',
                                                                },
                                                            }),
                                                    }}
                                                    render={({ field }) => (
                                                        <>
                                                            <Form.Control
                                                                {...field}
                                                                value={field.value?.toUpperCase()}
                                                                onChange={(e) => field.onChange(e.target.value.toUpperCase())}
                                                                readOnly={company}
                                                            />
                                                            {modalForm.formState.errors.prefix && (
                                                                <span className="error-message">
                                                                    {modalForm.formState.errors.prefix.message}
                                                                </span>
                                                            )}
                                                        </>
                                                    )}
                                                />
                                            </Col>
                                        </>
                                    )
                                }
                            </Form.Group>

                            {/* Grupo 3: Campos específicos SHIPPER */}
                            {companyTypeWatcher?.value === CompanyTypesEnum.SHIPPER && (
                                <Form.Group as={Row}>
                                    <>
                                        <Col md={3}>
                                            <Form.Label>Tipo de Servicio *</Form.Label>
                                            <Controller
                                                control={modalForm.control}
                                                name="serviceType"
                                                render={({ field }) => (
                                                    <CustomRadioButton
                                                        options={servicesTypes}
                                                        onChange={field.onChange}
                                                        value={field.value}
                                                        name='serviceType'
                                                    />
                                                )}
                                            />
                                        </Col>
                                        <Col md={3}>
                                            <Form.Label>Tipo de Orden *</Form.Label>
                                            <Controller
                                                control={modalForm.control}
                                                name="companyOrderTypes"
                                                rules={{ required: 'Este campo es obligatorio.' }}
                                                render={({ field: { onChange, value } }) => (
                                                    <>
                                                        <CustomCheckbox
                                                            options={orderTypes?.map((e) => ({
                                                                value: e.idOrderType,
                                                                label: e.name
                                                            })) || []}
                                                            onChange={onChange}
                                                            selectedOptions={value || []}
                                                        />
                                                        {modalForm.formState.errors.companyOrderTypes && (
                                                            <span className="error-message">
                                                                {modalForm.formState.errors.companyOrderTypes.message}
                                                            </span>
                                                        )}
                                                    </>
                                                )}
                                            />
                                        </Col>
                                        <Col md={3}>
                                            <Form.Label>Tipo de Pago *</Form.Label>
                                            <Controller
                                                control={modalForm.control}
                                                name="companyPaymentTypes"
                                                rules={{ required: 'Este campo es obligatorio.' }}
                                                render={({ field: { onChange, value } }) => (
                                                    <>
                                                        <CustomCheckbox
                                                            options={paymentTypes?.map((e) => ({
                                                                value: e.idPaymentType,
                                                                label: e.name
                                                            })) || []}
                                                            onChange={onChange}
                                                            selectedOptions={value || []}
                                                        />
                                                        {modalForm.formState.errors.companyPaymentTypes && (
                                                            <span className="error-message">
                                                                {modalForm.formState.errors.companyPaymentTypes.message}
                                                            </span>
                                                        )}
                                                    </>
                                                )}
                                            />
                                        </Col>
                                        <Col md={3}>
                                            <Form.Label style={{ visibility: 'hidden' }}>Aplica carta porte</Form.Label>
                                            <Form.Check
                                                type="switch"
                                                id="custom-switch"
                                                label="Aplica carta porte"
                                                checked={isCartaPorteChecked}
                                                onChange={() => setIsCartaPorteChecked(!isCartaPorteChecked)}
                                            />
                                        </Col>
                                    </>
                                </Form.Group>
                            )
                            }

                            {/* Grupo 3.1: Carta porte  */}
                            {isCartaPorteChecked && companyTypeWatcher?.value === CompanyTypesEnum.SHIPPER && (
                                <>
                                    <Form.Group as={Row}>
                                        <Col sm={3}>
                                            <Form.Label>Código producto/servicio *</Form.Label>
                                            <Controller
                                                control={modalForm.control}
                                                name="productServiceCode"
                                                rules={{ required: 'Código producto/servicio requerido' }}
                                                render={({ field }) => (
                                                    <>
                                                        <Form.Control
                                                            {...field}
                                                            className="form-control"
                                                            placeholder="Código producto / servicio"
                                                            maxLength={100}
                                                        />
                                                        {modalForm.formState.errors.productServiceCode && (
                                                            <span className="error-message">
                                                                {modalForm.formState.errors.productServiceCode.message}
                                                            </span>
                                                        )}
                                                    </>
                                                )}
                                            />
                                        </Col>
                                        <Col sm={3}>
                                            <Form.Label>Descripción producto/servicio *</Form.Label>
                                            <Controller
                                                control={modalForm.control}
                                                name="productServiceDescription"
                                                rules={{ required: 'Descripción producto/servicio requerido' }}
                                                render={({ field }) => (
                                                    <>
                                                        <Form.Control
                                                            {...field}
                                                            className="form-control"
                                                            placeholder="Descripción producto / servicio"
                                                            maxLength={100}
                                                        />
                                                        {modalForm.formState.errors.productServiceDescription && (
                                                            <span className="error-message">
                                                                {modalForm.formState.errors.productServiceDescription.message}
                                                            </span>
                                                        )}
                                                    </>
                                                )}
                                            />
                                        </Col>
                                        <Col sm={3}>
                                            <Form.Label>Código unidad peso *</Form.Label>
                                            <Controller
                                                control={modalForm.control}
                                                name="weightUnitCode"
                                                rules={{ required: 'Código unidad peso es requerido' }}
                                                render={({ field }) => (
                                                    <>
                                                        <Form.Control
                                                            {...field}
                                                            className="form-control"
                                                            placeholder="Código unidad peso"
                                                            maxLength={100}
                                                        />
                                                        {modalForm.formState.errors.weightUnitCode && (
                                                            <span className="error-message">
                                                                {modalForm.formState.errors.weightUnitCode.message}
                                                            </span>
                                                        )}
                                                    </>
                                                )}
                                            />
                                        </Col>
                                        <Col sm={3}>
                                            <Form.Label>Descripción unidad peso *</Form.Label>
                                            <Controller
                                                control={modalForm.control}
                                                name="weightUnitDescription"
                                                rules={{ required: 'Descripción unidad peso es requerido' }}
                                                render={({ field }) => (
                                                    <>
                                                        <Form.Control
                                                            {...field}
                                                            className="form-control"
                                                            placeholder="Descripción unidad peso"
                                                            maxLength={100}
                                                        />
                                                        {modalForm.formState.errors.weightUnitDescription && (
                                                            <span className="error-message">
                                                                {modalForm.formState.errors.weightUnitDescription.message}
                                                            </span>
                                                        )}
                                                    </>
                                                )}
                                            />
                                        </Col>
                                    </Form.Group>
                                </>
                            )
                            }

                            { /* Grupo 4: Campos específicos LOGISTICS OPERATOR y DSPs */}
                            { ( companyTypeWatcher?.value === CompanyTypesEnum.LOGISTICS_OPERATOR ||
                                companyTypeWatcher?.value === CompanyTypesEnum.DSP ) && (
                                <>
                                    <Form.Group as={Row}>
                                        <Col md={3}>
                                            <Form.Label>Tipos de Servicio *</Form.Label>
                                            <Controller
                                                control={modalForm.control}
                                                name="operatorServiceCapabilities"
                                                rules={{ required: 'Este campo es obligatorio.' }}
                                                render={({ field: { onChange, value } }) => (
                                                    <>
                                                        <CustomCheckbox
                                                            options={logisticsServiceTypes?.map((e) => ({
                                                                value: e.idLogisticsServiceType,
                                                                label: e.name
                                                            })) || []}
                                                            onChange={onChange}
                                                            selectedOptions={value || []}
                                                        />
                                                        {modalForm.formState.errors.operatorServiceCapabilities && (
                                                            <span className="error-message">
                                                                {modalForm.formState.errors.operatorServiceCapabilities.message}
                                                            </span>
                                                        )}
                                                    </>
                                                )}
                                            />
                                        </Col>
                                        <Col sm={3}>
                                            <Form.Label>Clasificación *</Form.Label>
                                            <Controller
                                                control={modalForm.control}
                                                name="operatorTier"
                                                rules={{ required: 'Este campo es obligatorio.' }}
                                                render={({ field }) => (
                                                    <>
                                                        <Select
                                                            {...field}
                                                            isClearable
                                                            styles={customStyles}
                                                            onChange={(option) => field.onChange(option || null)}
                                                            options={operatorTierOptions}
                                                        />
                                                        {modalForm.formState.errors.operatorTier && (
                                                            <span className="error-message">
                                                                {modalForm.formState.errors.operatorTier.message}
                                                            </span>
                                                        )}
                                                    </>
                                                )}
                                            />
                                        </Col>
                                    </Form.Group>
                                </>
                                )
                            }
                            { /* Grupo 4: Campos específicos LOGISTICS OPERATOR */}
                            {companyTypeWatcher?.value === CompanyTypesEnum.LOGISTICS_OPERATOR && (
                                <>
                                    <Form.Group as={Row}>
                                        <Table striped bordered className="m-2">
                                            <thead>
                                                <tr>
                                                    <th className="text-bold text-center" colSpan="6">
                                                        Asociar HUB
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th className="col-3">HUB</th>
                                                    <th className="col-2">Cuenta</th>
                                                    <th className="col-1"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <Controller
                                                            control={operatorBranchForm.control}
                                                            name="branch"
                                                            render={({ field }) => (
                                                                <>
                                                                    <Select
                                                                        {...field}
                                                                        isClearable
                                                                        styles={customStyles}
                                                                        options={
                                                                            branches && Object.keys(branches).length > 0
                                                                                ? branches.items
                                                                                    .filter(
                                                                                        (f) =>
                                                                                            f.isActive &&
                                                                                            parseInt(f.idCountry) === parseInt(countryWatcher?.value)
                                                                                    )
                                                                                    .map((ele, key) => ({
                                                                                        value: ele.idBranch,
                                                                                        label: ele.branchName,
                                                                                    }))
                                                                                : []
                                                                        }
                                                                    />
                                                                    {operatorBranchForm.formState.errors.branch && (
                                                                        <span className="error-message">
                                                                            {operatorBranchForm.formState.errors.branch.message}
                                                                        </span>
                                                                    )}
                                                                </>
                                                            )}
                                                        />
                                                    </td>
                                                    <td>
                                                        <Controller
                                                            control={operatorBranchForm.control}
                                                            name="account"
                                                            render={({ field }) => (
                                                                <>
                                                                    <input
                                                                        {...field}
                                                                        className="form-control"
                                                                        type="text"
                                                                        name="account"
                                                                        placeholder="Numero de cuenta"
                                                                        maxLength={100}
                                                                    />
                                                                    {operatorBranchForm.formState.errors.account && (
                                                                        <span className="error-message">
                                                                            {operatorBranchForm.formState.errors.account.message}
                                                                        </span>
                                                                    )}
                                                                </>
                                                            )}
                                                        />
                                                    </td>
                                                    <td>
                                                        <button
                                                            className="btn btn-primary"
                                                            type="button"
                                                            onClick={addBranch}
                                                        >
                                                            Agregar
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                        <Table bordered className="m-2">
                                            <thead>
                                                <tr>
                                                    <th className="text-bold text-center" colSpan="6">
                                                        HUBs
                                                    </th>
                                                </tr>
                                                {operatorBranchWatcher.length > 0 && (
                                                    <tr>
                                                        <th className="col-5">HUB</th>
                                                        <th className="col-5">Cuenta</th>
                                                        <th className="col-2"></th>
                                                    </tr>
                                                )}
                                            </thead>
                                            <tbody>
                                                <Controller
                                                    control={operatorBranchForm.control}
                                                    name="operatorsBranch"
                                                    render={() => (
                                                        <>
                                                            {operatorBranchWatcher.map((item, index) => (
                                                                <tr>
                                                                    <td>{item.branch?.label}</td>
                                                                    <td>{item.account}</td>
                                                                    <td>
                                                                        {
                                                                            <>
                                                                                <button
                                                                                    title="Eliminar"
                                                                                    className="btn btn-danger btn-sm btn-circle"
                                                                                    type="button"
                                                                                    onClick={() => handleRemoveOperator(item)}
                                                                                >
                                                                                    <i className="fas fa-trash fa-xs"></i>
                                                                                </button>
                                                                            </>
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                            {operatorBranchForm.formState.errors.operatorsBranch && (
                                                                <tr>
                                                                    <td>
                                                                        <span className="error-message text-center">
                                                                            {operatorBranchForm.formState.errors.operatorsBranch.message}
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </>
                                                    )}
                                                />
                                            </tbody>
                                        </Table>
                                    </Form.Group>

                                </>
                            )
                            }
                            <Modal.Footer>
                                <Button variant="secondary" onClick={closeModal}>
                                    Cancelar
                                </Button>
                                <Button variant="primary" type="submit">
                                    Guardar
                                </Button>
                            </Modal.Footer>
                        </Form>
                    </FormProvider>
                )
            }
        </Modal>
    );
};

const mapStateToProps = (state) => {
    return {
        company: state.companyState.company,
        countries: state.countryState.countries,
        departmentsByCountry: state.departmentState.departmentsByCountry,
        citiesByDepartment: state.cityState.citiesByDepartment,
        neighborhoodsByCity: state.neighborhoodState.neighborhoodsByCity,
        branches: state.branchState.branches,
        successfulCreateCompany: state.companyState.successfulCreateCompany,
        errorsCreateCompany: state.companyState.errorsCreateCompany,
        successfulUpdateCompany: state.companyState.successfulUpdateCompany,
        errorsUpdateCompany: state.companyState.errorsUpdateCompany,
        paymentTypes: state.paymentTypeState.paymentTypes,
        orderTypes: state.orderTypeState.orderTypes,
        logisticsServiceTypes: state.logisticsServiceTypeState.logisticsServiceTypes,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        reduxPostCompany: (payload) =>
            dispatch({
                type: 'CREATE_COMPANY_REQUEST',
                value: payload,
            }),
        reduxPatchCompany: (payload) =>
            dispatch({
                type: 'UPDATE_COMPANY_REQUEST',
                value: payload,
            }),
        reduxResetCompanyForm: () =>
            dispatch({
                type: 'RESET_COMPANY_FORM',
            }),
        reduxGetCountries: (payload) =>
            dispatch({
                type: 'FETCH_COUNTRIES_REQUEST',
                value: payload,
            }),
        reduxGetDepartmentByCountry: (payload) =>
            dispatch({
                type: 'READBYCOUNTRY_DEPARTMENT_REQUEST',
                value: payload,
            }),
        reduxResetDepartmentsByCountry: () =>
            dispatch({
                type: 'RESET_BYCOUNTRY_DEPARTMENT',
            }),
        reduxGetCitiesByDepartment: (payload) =>
            dispatch({
                type: 'READBYDEPARTMENT_CITY_REQUEST',
                value: payload,
            }),
        reduxResetCitiesByDepartment: () =>
            dispatch({
                type: 'RESET_BYDEPARTMENT_CITY',
            }),
        reduxGetNeighborhoodsByCity: (payload) =>
            dispatch({
                type: 'READBYCITY_NEIGHBORHOOD_REQUEST',
                value: payload,
            }),
        reduxResetNeighborhoodsByCity: () =>
            dispatch({
                type: 'RESET_BYCITY_NEIGHBORHOOD',
            }),
        reduxGetBranches: (payload) =>
            dispatch({
                type: 'FETCH_BRANCHES_REQUEST',
                value: payload,
            }),
        reduxDeleteOperatorBranch: (payload) =>
            dispatch({
                type: 'DELETE_OPERATOR_BRANCH_REQUEST',
                value: payload,
            }),
        reduxGetOrderTypes: (payload) =>
            dispatch({
                type: 'FETCH_ORDER_TYPES_REQUEST',
                value: payload,
            }),
        reduxGetPaymentTypes: (payload) =>
            dispatch({
                type: 'FETCH_PAYMENT_TYPES_REQUEST',
                value: payload,
            }),
        reduxGetLogisticsServiceTypes: (payload) =>
            dispatch({
                type: 'FETCH_LOGISTICS_SERVICE_TYPES_REQUEST',
                value: payload,
            }),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(UpsertCompany);